import React, { useState, useEffect, useCallback } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import './styles.css'

export async function fetchLinkToken(): Promise<string> {
    const response = await fetch('/api/plaid/create-link-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });
    const data = await response.json();
    console.log(data);
    return data.link_token;
  }

  export async function sendPublicTokenToBackend(publicToken: string, accountId: string, institutionName: string, institutionId: string): Promise<any> {
    const response = await fetch('/api/plaid/get-access-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ publicToken: publicToken, accountId: accountId, institutionName: institutionName, institutionId: institutionId }),
      credentials: 'include'
    });
    const data = await response.json();
    console.log(data);
    return data.access_token;
  }

  export async function fetchInstitutionDetails(institutionId: string): Promise<any> {
    const response = await fetch(`/api/plaid/institution/${institutionId}`, { credentials: 'include' });
    const data = await response.json();
    return data;
  }

  export async function fetchConnectedAccounts(): Promise<any> {
    const response = await fetch(`/api/plaid/get-connected-accounts`, { credentials: 'include' });
    const data = await response.json();
    return data;
  }

  export async function removeBrokerageAccount(id: number): Promise<any> {
    const response = await fetch(`/api/plaid/remove-account/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    const data = await response.json();
    return data;
  }

  const BrokerageManagement: React.FC = () => {
    const [linkToken, setLinkToken] = useState<string | null>(null);
    const [accounts, setAccounts] = useState<any[]>([]);

    useEffect(() => {
        loadInitialData();
    }, []);

    const loadInitialData = async () => {
        const token = await fetchLinkToken();
        setLinkToken(token);
        const accountData = await fetchConnectedAccounts();
        console.log(accountData);
        setAccounts(accountData);
        fetchLogos(accountData);
    };

    const fetchLogos = async (accounts: any[]) => {
        const updatedAccounts = await Promise.all(accounts.map(async account => {
            const logoData = await fetchInstitutionDetails(account.institution_id);
            return { ...account, logoUrl: `data:image/png;base64,${logoData.logo}` };
        }));
        setAccounts(updatedAccounts);
    };

    const onSuccess = async (publicToken: string, metadata: any) => {
        try {
          const accessToken = await sendPublicTokenToBackend(publicToken, metadata.account_id, metadata.institution.name, metadata.institution.institution_id);
          loadInitialData();
        } catch (error) {
          console.error('Error fetching access token:', error);
        }
    };

    const config = {
      token: linkToken!,
      onSuccess,
    };

    const { open, ready } = usePlaidLink(config);

    const handleRemove = async (id: number) => {
        await removeBrokerageAccount(id);
        setAccounts(accounts.filter(account => account.id !== id));
    };

    return (
      <div className="container">
          <div className="header">
              <h1>Brokerage Account Management</h1>
              <button className="add-account-button" onClick={() => open()} disabled={!ready || !linkToken}>
                  Add New Brokerage Account
              </button>
          </div>
          <div className="accounts-list">
              {accounts.map((account) => (
                  <div key={account.id} className="account-item">
                      <img src={account.logoUrl || 'placeholder.jpg'} alt={account.name} />
                      <p>{account.name}</p>
                      <button onClick={() => handleRemove(account.id)}>Remove</button>
                  </div>
              ))}
          </div>
      </div>
  );
};

export default BrokerageManagement;